import { render, staticRenderFns } from "./optionCity.vue?vue&type=template&id=70d3697e&"
import script from "./optionCity.vue?vue&type=script&lang=js&"
export * from "./optionCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports